
export const getSckanComposerVersion = () => {
	return require('../../package.json').version;
}
